module.exports = __webpack_public_path__ + "static/img/bg_vip@2x.1276832.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newUi-icon/bg_vip@2x.png
// module id = US/L
// module chunks = 96